export default __webpack_public_path__ + "static/e2d3e41c28fa6f301ec9387e55f3fcdc.png";